import { asyncDebounce } from 'common/helper/async/debounce';
import { AutocompleteStoreFactory } from 'common/module/autocomplete/store.factory';
import { AutocompleteStoreCacheableDecoratorFactory } from 'common/module/autocomplete/store/cacheable-decorator.factory';
import { BrokerAutocompleteDecorator } from 'common/module/broker/autocomplete/decorator';
import { BrokerAutocompleteStoreInterface } from 'common/module/broker/autocomplete/store.interface';

export function BrokerAutocompleteStoreFactory(): BrokerAutocompleteStoreInterface {
  let autocompleteStore = AutocompleteStoreFactory();

  // Add cache feature
  autocompleteStore = AutocompleteStoreCacheableDecoratorFactory(autocompleteStore);

  // Add broker specific features
  autocompleteStore = new BrokerAutocompleteDecorator(autocompleteStore, asyncDebounce);

  return <BrokerAutocompleteStoreInterface>autocompleteStore;
}
